export default __webpack_public_path__ + "static/media/packaging-desktop@3x.5f48a64e.jpg";